export default "__VITE_ASSET__CoYyQ0Hm__"